// extracted by mini-css-extract-plugin
module.exports = {"link_card":"linkCard_link_card____rm7","isOpen":"linkCard_isOpen__WZIWS","link_card_desktop":"linkCard_link_card_desktop__wA8lu"};